import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.inputElement = this.element.querySelector('.query-input')
    this.formElement = this.inputElement.closest('form')

    this.inputElement.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') {
        event.preventDefault()
        this.formElement.submit()
      }
    })
  }
}
